import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Checkbox, FormControl, FormControlLabel, Grid, Radio, TextField, Typography } from '@mui/material';

import InputCreateHtml from './InputCreateHtml';
import { useFormContext } from 'react-hook-form';
import { FormDropZone, GroupRadioButtonForm, ModalGeneral, TextFieldNumber, VisorPDF } from 'ui-component';
import { BigPlayButton, ControlBar, VolumeMenuButton, Player } from 'video-react';
import { colors } from '@mui/material';
import { Delete, CloudDownload, PictureAsPdf } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import InputLink from './enlancesView';
import EnlacePreview from './EnlacePreview';

const useStyles = makeStyles((theme) => ({
    helperTextError: {
        color: colors.red[500],
        marginLeft: '14px',
        marginRight: '14px',
        marginTop: '4px',
        fontSize: '0.75rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    },
    helperText: {
        color: 'black',
        marginLeft: '0px',
        marginRight: '14px',
        marginTop: '4px',
        fontSize: '1rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    },
    helperText2: {
        color: colors.grey[500],
        marginLeft: '14px',
        marginRight: '14px',
        marginTop: '4px',
        fontSize: '0.75rem',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    }
}));

const TIPOS_PERIODO_ABAJO = [3, 7, 10, 11];

const TIPOS_DIAS_OBLIGATORIO = [];

const FormDetalleActividad = ({ open, isAdd, data, ctl, isVer, ...props }) => {
    const classes = useStyles();
    const [modal, setModal] = useState({ open: false, titulo: '' });
    const [habilitarPeriodo, setHabilitarPeriodo] = useState(false);

    const {
        register,
        watch,
        formState: { errors },
        control,
        setValue,
        getValues,
        unregister
    } = useFormContext();

    const idTipoActividad = watch('idTipoActividad') === undefined ? data?.idTipoActividad : watch('idTipoActividad');
    const clickEliminarArchivoActivo = () => setValue('archivoActivo', null);
    const cerrarModal = () => setModal({ open: false });

    const abrirPDF = () => {
        setModal({
            open: true,
            formulario: VisorPDF,
            propsModal: {
                isBase64: true,
                data: data,
                title: 'PDF actividad' + data?.titulo
            }
        });
    };

    const descargarArchivo = () => {
        window.open(data?.linkVideo, '_blank', 'noreferrer');
    };

    //  HANDLER CHECKBOX PERIODO
    const handleTogglePeriodo = (e) => {
        const checked = e.target.checked;
        setHabilitarPeriodo(checked);
        if (checked) {
            setValue('diasHabilitar', null);
        } else {
            setValue('diaInicio', null);
            setValue('diaFin', null);
        }
    };

    const extensionesValidasAudio = ['audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/*'];

    const extensionesValidasDescargables = [
        'image/*',
        'video/*',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/plain',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/xml',
        'text/xml',
        'audio/*',
        'application/zip',
        'application/x-zip-compressed'
    ];

    const extensionesNoValidas = [
        'application/x-msdownload',
        'application/javascript',
        'text/javascript',
        'application/x-msdos-program',
        'application/x-sh',
        'text/x-sh',
        'application/octet-stream',
        ''
    ];

    const dropZoneRules = {
        required: { value: true, message: 'Campo requerido' },
        validate: (value) => !extensionesNoValidas.includes(value[0]?.type) || 'Extensión no válida'
    };

    const dropZoneRulesAudio = {
        required: { value: true, message: 'Campo requerido' },
        validate: (value) => {
            const file = value?.[0]?.file;
            if (!file) return 'Archivo inválido';
            return file.type.startsWith('audio/') || file.name.match(/\.(wav|mp3|ogg)$/i) || 'Solo se permiten archivos de audio';
        }
    };

    useEffect(() => {
        if (data) {
            register('idTipoActividad');
            setValue('idTipoActividad', data?.idTipoActividad);

            register('solicitarEvidencia');
            setValue('solicitarEvidencia', data?.solicitarEvidencia);

            if (data.diaInicio != null && data.diaFin != null) {
                setHabilitarPeriodo(true);
                setValue('diaInicio', data.diaInicio);
                setValue('diaFin', data.diaFin);
                setValue('diasHabilitar', null);
            } else {
                setHabilitarPeriodo(false);
                setValue('diaInicio', null);
                setValue('diaFin', null);
                setValue('diasHabilitar', data?.diasHabilitar ?? null);
            }
        } else {
            register('solicitarEvidencia');
            setValue('solicitarEvidencia', 0);
            setHabilitarPeriodo(false);
        }

        if (data && [2, 4, 5, 6, 8].includes(Number(data?.idTipoActividad))) {
            register('archivoActivo');
            setValue('archivoActivo', data?.linkVideo);
        } else unregister('archivoActivo');
    }, [data]);

    // CHECKBOX + CAMPOS DE PERIODO
    const renderPeriodoBlock = () => (
        <>
            <Grid item xs={12}>
                <FormControlLabel
                    control={<Checkbox checked={habilitarPeriodo} onChange={handleTogglePeriodo} color="primary" />}
                    label="Habilitar por periodo de tiempo"
                />
            </Grid>

            {habilitarPeriodo && (
                <>
                    <Grid item xs={6}>
                        <TextFieldNumber
                            id="txt-dia-inicio"
                            label="Día inicio *"
                            name="diaInicio"
                            error={errors?.diaInicio?.message}
                            defaultValue={data?.diaInicio}
                            suffix=" día(s)"
                            decimalScale={0}
                            control={control}
                            rules={{
                                required: { value: true, message: 'Campo requerido' },
                                validate: (val) => Number(val) >= 0 || 'El valor mínimo es 0 (hoy)'
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextFieldNumber
                            id="txt-dia-fin"
                            label="Día fin *"
                            name="diaFin"
                            error={errors?.diaFin?.message}
                            defaultValue={data?.diaFin}
                            suffix=" día(s)"
                            decimalScale={0}
                            control={control}
                            rules={{
                                required: { value: true, message: 'Campo requerido' },
                                validate: (val) => {
                                    const inicio = Number(getValues('diaInicio'));
                                    const fin = Number(val);
                                    if (fin <= 0) return 'El valor mínimo es 1';
                                    if (fin <= inicio) return 'Día fin debe ser mayor a Día inicio';
                                    return true;
                                }
                            }}
                        />
                    </Grid>
                </>
            )}
        </>
    );

    const renderDiasHabilitar = () => {
        if (habilitarPeriodo || !idTipoActividad) return null;

        const esObligatorio = TIPOS_DIAS_OBLIGATORIO.includes(Number(idTipoActividad));

        return (
            <Grid item xs={4}>
                <TextFieldNumber
                    id="txt-num-dia-habilitar"
                    label={esObligatorio ? 'Días para liberar*' : 'Días para liberar'}
                    name="diasHabilitar"
                    decimalScale={0}
                    error={errors?.diasHabilitar?.message}
                    defaultValue={data?.diasHabilitar}
                    suffix=" días"
                    control={control}
                    rules={{
                        required: esObligatorio ? { value: true, message: 'Campo requerido' } : false,
                        validate: (value) => {
                            if (!esObligatorio && (value === null || value === undefined || value === '')) return true;
                            return Number(value) > 0 || 'la cantidad mínima es 1';
                        }
                    }}
                />
            </Grid>
        );
    };

    const mostrarPeriodoAbajo = TIPOS_PERIODO_ABAJO.includes(Number(idTipoActividad));
    const mostrarPeriodoArriba = idTipoActividad && !mostrarPeriodoAbajo && Number(idTipoActividad) !== 9;

    return (
        <Grid container spacing={2}>
            {/*  TÍTULO Y TIPO DE MATERIAL  */}
            {!isVer && (
                <>
                    <Grid item xs={6}>
                        <TextField
                            id="txt-tit"
                            label="Título *"
                            size="small"
                            fullWidth
                            {...register('titulo', {
                                required: { value: true, message: 'Campo requerido' },
                                validate: (value) => value.match(/(^\s+|\s+$)/g) == null || 'El inicio o el final no pueden ser espacios'
                            })}
                            error={Boolean(errors.titulo)}
                            helperText={errors.titulo?.message}
                            defaultValue={data?.titulo}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="txt-tipo"
                            label="Tipo de material *"
                            size="small"
                            fullWidth
                            select
                            SelectProps={{ native: true }}
                            disabled={data?.idTipoActividad}
                            {...register('idTipoActividad', {
                                required: { value: !data?.idTipoActividad, message: 'Campo requerido' }
                            })}
                            error={Boolean(errors.idTipoActividad)}
                            helperText={errors.idTipoActividad?.message}
                            defaultValue={data?.idTipoActividad}
                            onChange={(event) => {
                                setValue('idTipoActividad', event.target.value);
                                setValue('archivo', []);
                            }}
                            multiline
                        >
                            <option />
                            <option value="1">Lectura</option>
                            <option value="2">Archivo</option>
                            <option value="3">Examen</option>
                            <option value="7">Encuesta</option>
                            <option value="8">Audio</option>
                            <option value="9">Enlace</option>
                            <option value="10">Examen completo</option>
                            <option value="11">Encuesta Completa</option>
                        </TextField>
                    </Grid>
                </>
            )}

            {idTipoActividad == 9 && (
                <>
                    <Grid item xs={12}>
                        <InputLink
                            control={control}
                            name="enlace"
                            label="Enlace del recurso"
                            defaultValue={data?.enlace}
                            hidePreview
                            rules={{
                                required: 'El enlace es requerido',
                                pattern: {
                                    value: /^https?:\/\/.+/i,
                                    message: 'Ingresa una URL válida'
                                }
                            }}
                        />
                    </Grid>

                    {!isVer && renderPeriodoBlock()}
                    {!isVer && renderDiasHabilitar()}

                    <Grid item xs={12}>
                        <EnlacePreview name="enlace" />
                    </Grid>
                </>
            )}

            {/*  PERIODO ARRIBA — Lectura, Archivo, PDF, Imagen, Descargable, Audio  */}
            {!isVer && mostrarPeriodoArriba && renderPeriodoBlock()}
            {!isVer && mostrarPeriodoArriba && !habilitarPeriodo && renderDiasHabilitar()}
            {!isVer && [2, 4, 5, 6, 8].includes(Number(idTipoActividad)) && (
                <>
                    <Grid item xs={9}>
                        <GroupRadioButtonForm
                            id="frm-btn-evi"
                            control={control}
                            name="solicitarEvidencia"
                            label="Solicitar Evidencia"
                            defaultValue={data?.solicitarEvidencia || '0'}
                            rules={{ required: { value: true, message: 'Campo requerido' } }}
                        >
                            <FormControlLabel value="1" control={<Radio />} label="SI" />
                            <FormControlLabel value="0" control={<Radio />} label="NO" />
                        </GroupRadioButtonForm>
                    </Grid>

                    {[2, 4, 5, 6].includes(Number(idTipoActividad)) && (
                        <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                                Se aceptan archivos ZIP, PDF, imágenes, videos, documentos Word, Excel y audio.
                            </Typography>
                        </Grid>
                    )}
                    {[8].includes(Number(idTipoActividad)) && (
                        <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                                Se aceptan archivos MP3, WAV y OPUS
                            </Typography>
                        </Grid>
                    )}
                </>
            )}

            {/*  EXAMEN / EXAMEN COMPLETO  */}
            {[3, 10].includes(Number(idTipoActividad)) && (
                <>
                    <Grid item xs={4}>
                        <TextFieldNumber
                            id="txt-num-cal"
                            label="Calificación aprobatoria*"
                            name="calificacion"
                            error={errors?.calificacion?.message}
                            defaultValue={data?.calificacion}
                            control={control}
                            rules={{
                                required: { value: true, message: 'Campo requerido' }
                            }}
                        />
                    </Grid>
                    {!habilitarPeriodo && renderDiasHabilitar()}
                    <Grid item xs={4}>
                        <TextFieldNumber
                            id="txt-num-int"
                            label="Número de intentos*"
                            name="numIntentos"
                            decimalScale={0}
                            suffix=" Intentos"
                            error={errors?.numIntentos?.message}
                            defaultValue={data?.numIntentos}
                            control={control}
                            rules={{
                                required: { value: true, message: 'Campo requerido' },
                                validate: (calificacion) => Number(calificacion) > 0 || 'la cantidad mínima es 1'
                            }}
                        />
                    </Grid>
                </>
            )}

            {/*  ENCUESTA / ENCUESTA COMPLETA  */}
            {[7, 11].includes(Number(idTipoActividad)) && !habilitarPeriodo && renderDiasHabilitar()}

            {/*  AUDIO  */}
            {[8].includes(Number(idTipoActividad)) &&
                (watch('archivoActivo') == null && [0, null, undefined].includes(isVer) ? (
                    <Grid item xs={12}>
                        <FormDropZone
                            id="drp-zn-audio"
                            control={control}
                            name="archivo"
                            rules={dropZoneRulesAudio}
                            acceptedFiles={extensionesValidasAudio}
                        />
                        <Typography className={classes.helperTextError}>{errors?.archivo?.message}</Typography>
                    </Grid>
                ) : (
                    <Grid item xs={12}>
                        {!isVer && (
                            <Button color="error" variant="contained" onClick={clickEliminarArchivoActivo}>
                                <Delete /> Eliminar audio
                            </Button>
                        )}
                        <audio controls style={{ width: '100%', marginTop: 16 }}>
                            <source src={data?.linkVideo} type="audio/mpeg" />
                            <track kind="captions" srcLang="es" label="Español" src="" />
                            Tu navegador no soporta audio.
                        </audio>
                    </Grid>
                ))}

            {/*  VIDEO / IMAGEN  */}
            {[2, 5].includes(Number(idTipoActividad)) &&
                (watch('archivoActivo') == null && [0, null, undefined].includes(isVer) ? (
                    <Grid item xs={12}>
                        <FormDropZone
                            id="drp-zn-arc"
                            control={control}
                            name="archivo"
                            rules={dropZoneRules}
                            acceptedFiles={extensionesValidasDescargables}
                        />
                        <br />
                        <Typography className={classes.helperTextError}>{errors?.archivo?.message}</Typography>
                    </Grid>
                ) : (
                    <Grid item xs={12} container>
                        {!isVer && (
                            <Grid item xs={2}>
                                <ButtonGroup variant="contained" aria-label="outlined primary button group">
                                    <Button id="btn-err" color="error" onClick={clickEliminarArchivoActivo}>
                                        <Delete />
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        )}
                        {idTipoActividad == 2 ? (
                            <Grid item xs={12}>
                                <Player src={data?.linkVideo}>
                                    <BigPlayButton position="center" />
                                </Player>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <img src={data?.linkVideo} alt="imagen actividad" width="100%" height="500px" />
                            </Grid>
                        )}
                    </Grid>
                ))}

            {/*  LECTURA  */}
            {idTipoActividad == 1 && (
                <Grid item xs={12}>
                    <InputCreateHtml id="inp-cre-htm" control={control} name="lectura" label="Lectura" defaultValue={data?.lectura} />
                </Grid>
            )}

            {/*  PDF / DESCARGABLE */}
            {[4, 6].includes(Number(idTipoActividad)) && (
                <>
                    {watch('archivoActivo') == null && [0, null, undefined].includes(isVer) ? (
                        <Grid item xs={12}>
                            <FormDropZone
                                id="drp-zn-pdf"
                                control={control}
                                name="archivo"
                                rules={dropZoneRules}
                                acceptedFiles={idTipoActividad == 4 ? ['application/pdf'] : extensionesValidasDescargables}
                            />
                            <br />
                            <Typography className={classes.helperTextError}>{errors?.archivo?.message}</Typography>
                        </Grid>
                    ) : (
                        <Grid container spacing={2}>
                            <Grid item xs={12}></Grid>
                            {!isVer && (
                                <Grid item xs={4}>
                                    <Button id="btn-del-arc" color="error" variant="contained" onClick={clickEliminarArchivoActivo}>
                                        <Delete />
                                        Eliminar archivo
                                    </Button>
                                </Grid>
                            )}
                            <Grid item xs={8}>
                                <Button
                                    id="btn-ver"
                                    component="label"
                                    role={undefined}
                                    variant="contained"
                                    tabIndex={-1}
                                    startIcon={idTipoActividad == 4 ? <PictureAsPdf /> : <CloudDownload />}
                                    color="primary"
                                    onClick={idTipoActividad == 4 ? abrirPDF : descargarArchivo}
                                >
                                    {idTipoActividad == 4 ? 'Abrir PDF' : 'Ver archivo'}
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </>
            )}

            {!isVer && mostrarPeriodoAbajo && renderPeriodoBlock()}

            <ModalGeneral open={modal.open} width="md" titulo={modal.titulo} OnCerrar={cerrarModal}>
                {modal.formulario && <modal.formulario {...modal.propsModal} />}
            </ModalGeneral>
        </Grid>
    );
};

export default FormDetalleActividad;
